<template>
  <div class="forget-password-container">
    <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions"></OnboardingMenu>
    <div class="banner">
      <img :src="bannerUrl" alt="">
    </div>
    <onboarding-message class="message" :messages="messages"></onboarding-message>
    <div class="title">{{ $t('onboarding.common.forgetPasswordTitle') }}</div>
    <onboarding-divider />
    <div class="input-form-div">
      <onboarding-input v-model="email" :label="$t('onboarding.common.email')" isRequired="true"/>
    </div>
    <div class="next-button">
      <onboarding-button @click.native="handleReset" :text="$t('onboarding.common.btn.reset')" type='normal'></onboarding-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OnboardingInput from '@/components/onboarding/form/Input'
import OnboardingButton from '@/components/onboarding/form/Button'
import OnboardingMessage from '@/components/onboarding/form/Message'
import OnboardingDivider from '@/components/onboarding/form/Divider'
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingInput, OnboardingButton, OnboardingMessage, OnboardingDivider, OnboardingMenu
  },
  data () {
    return {
      email: '',
      bannerUrl: ''
    }
  },
  computed: {
    isNestle () {
      return this.$parent.isNestle
    }
  },
  created () {
    this.initBannerUrl()
  },
  methods: {
    ...mapActions('onboarding', ['forgetOnboardingPassword']),
    initBannerUrl () {
      if (this.isNestle) {
        if (deviceType.isMobile) {
          this.bannerUrl = require('@/assets/image/onboarding/common/mobile-banner.jpg')
        } else {
          this.bannerUrl = require('@/assets/image/onboarding/common/banner.png')
        }
      } else {
        this.bannerUrl = this.$parent.headerImage
      }
    },
    async handleReset () {
      try {
        const resp = await this.forgetOnboardingPassword({
          invitationId: this.invitationId,
          email: this.email
        })
        if (resp) {
          this.$alert(
            this.$t('onboarding.common.message.resetEmailSuccess'),
            this.$t('onboarding.common.alertTitle'),
            {
              customClass: 'alert-message-box',
              callback: action => {
                this.$router.push(`/onboarding/${this.invitationId}/login`)
              }
            }
          )
        }
      } catch (err) {
        if (err.code === 20003004) {
          this.$message.error(this.$t('onboarding.common.message.wrongEmail'))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
  .forget-password-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .banner {
      img {
        background-size: cover;
        width: 100%;
        height: auto;
      }
    }
    .message {
      position: fixed;
      top: 50px;
    }
    .title {
      font-weight: bolder;
      margin-top: 2rem;
      margin-bottom: 1.2rem;
      text-align: center;
    }
    .divider {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2.5rem;
      float: none;
    }
    .input-form-div {
      width: 100%;
      padding: 0 5%;
      .forget-password-link {
        display: block;
        text-align: right;
        font-size: 14px;
      }
    }
    .next-button {
        margin: 4rem 0;
        padding-bottom: 50px;
    }
  }
/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
}
</style>

<style lang="scss">
.alert-message-box {
  .el-message-box__message {
    font-size: 14px;
  }
}
</style>
